module.exports = __webpack_public_path__ + "assets/people-icon.ccf19cc9.svg";